module.exports = __webpack_public_path__ + "img/1526352974.ec81db26.jpg";